import axios from "axios";
import { useMemo } from "react";
import config from "../config";

// ---------- localStorage safe helper ----------
const safeJSONParse = (value, fallback = null) => {
  try {
    if (!value || value === "undefined" || value === "null") return fallback;
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export function useGuideData() {
  // read user ONCE safely
  const userData = useMemo(
    () => safeJSONParse(localStorage.getItem("user"), null),
    []
  );

  async function updateUserGuide(step) {
    if (!userData) return; // not logged in, nothing to update

    const existingGuide = Array.isArray(userData?.onBoarding?.guide)
      ? userData.onBoarding.guide
      : [];

    // avoid duplicates
    if (existingGuide.includes(step)) return;

    const guide = [...existingGuide, step];

    const doc = {
      onBoarding: {
        ...userData?.onBoarding,
        guide,
      },
    };

    try {
      const { data } = await axios.patch(
        `${config.USERS}/users`,
        {},
        {
          headers: {
            token: localStorage.getItem("access_token"),
            doc: encodeURIComponent(JSON.stringify(doc)),
          },
        }
      );

      // only update local user for non-regular users (your original logic)
      if (userData.role !== "user" && data?.value) {
        localStorage.setItem("user", JSON.stringify(data.value));
      }
    } catch (err) {
      console.error("Guide update failed:", err);
    }
  }

  const runJoyRideStep = (step) => {
    const freshUser = safeJSONParse(localStorage.getItem("user"), null);
    return freshUser?.onBoarding?.guide?.includes(step) || false;
  };

  return {
    updateUserGuide,
    runJoyRideStep,
  };
}

export default useGuideData;
